"use client";

import {
  useCallback,
  useState,
  type MouseEvent as ReactMouseEvent,
} from "react";

export function useResizablePanel(
  width: number,
  setWidth: (width: number) => void,
  { min = 280, max = 600 }: { min?: number; max?: number } = {}
) {
  const [isResizing, setIsResizing] = useState(false);

  const handleResizeStart = useCallback(
    (e: ReactMouseEvent) => {
      e.preventDefault();
      setIsResizing(true);
      const startX = e.clientX;
      const startWidth = width;

      const onMove = (moveEvent: MouseEvent) => {
        const delta = startX - moveEvent.clientX;
        setWidth(Math.min(max, Math.max(min, startWidth + delta)));
      };
      const onUp = () => {
        setIsResizing(false);
        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", onUp);
      };
      document.addEventListener("mousemove", onMove);
      document.addEventListener("mouseup", onUp);
    },
    [width, setWidth, min, max]
  );

  return { isResizing, handleResizeStart };
}
